var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-form-group',{class:{'has-error': _vm.errorField in _vm.$root.errors},attrs:{"label":_vm.label,"error-field":_vm.errorField}},[_c('o-checkbox-control',{staticClass:"w-100",attrs:{"readonly":_vm.readonly},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }